import instance from 'api/instance';
import { IGetCar, IGetCarBySu } from './types';
import qs from 'query-string';

export const getCars: IGetCar = (motordromeId) =>
	instance.post('/cars', { motordromeId });

export const getCarsBySu: IGetCarBySu = (params) => instance.get(`/cars?${qs.stringify(params, { skipEmptyString: true })}`);
